<ul class="m-0 flex list-none flex-col gap-5 px-0 py-4">
  @for (item of items(); track item.title) {
    <li>
      <sb-checklist-item
        [listIndex]="$index"
        [expanded]="item.title === expandedItem?.title"
        (mouseenter)="setExpandedItem(item)"
        [item]="item"
      />
    </li>
  }
</ul>

<div data-testid="checklist-footer-wrapper" (mouseenter)="clearExpandedItem()">
  <ng-content select="[sb-checklist-footer], sb-checklist-footer"></ng-content>
</div>
